import { useState, useEffect } from 'react'
import '../../assets/css/returnToTop.css'

export default function ReturnToTop() {

    const [visible, setVisible] = useState(false)



    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    useEffect(() => {
        const toggleVisible = () => {
            const scrolled = document.documentElement.scrollTop;
            console.log(">>>>>>>>>", scrolled)
            if (scrolled > 300) {
                setVisible(true)
            }
            else if (scrolled <= 300) {
                setVisible(false)
            }
        };
        window.addEventListener('scroll', toggleVisible);
    }, [visible])
    return (
        <a href="js:" id="return-to-top" onClick={scrollToTop} className={`${visible ? 'd-block' : 'd-none'}`} >
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="32px"  space="preserve"><path d="M18.221,7.206l9.585,9.585c0.879,0.879,0.879,2.317,0,3.195l-0.8,0.801c-0.877,0.878-2.316,0.878-3.194,0  l-7.315-7.315l-7.315,7.315c-0.878,0.878-2.317,0.878-3.194,0l-0.8-0.801c-0.879-0.878-0.879-2.316,0-3.195l9.587-9.585  c0.471-0.472,1.103-0.682,1.723-0.647C17.115,6.524,17.748,6.734,18.221,7.206z" /></svg>
        </a>
    )
}